export type PatientDoorReportData = {
  name: string;
  partialId: string;
  index: number;
  visitTime: string;
  visitType?: string;
  submittedBy: string;
  visitDate: string;
};

export type PatientInfoReportData = {
  email: string;
  phoneNumber: string;
  age: number;
  gender: string;
  firstName: string;
  lastName: string;
  id: string;
  lastVisit: string;
  assignDoctor?: string;
};

export const PATIENT_INFO_GENDER_MALE = "ז";
export const PATIENT_INFO_GENDER_FEMALE = "נ";

export const ATHENA_GENDER_MALE = "M";
export const ATHENA_GENDER_FEMALE = "F";

export type MergedPatientData = {
  id: string;
  index: number;
  gender: typeof ATHENA_GENDER_MALE | typeof ATHENA_GENDER_FEMALE;
  age: number;
  firstName: string;
  lastName: string;
  visitDateTime: Date | number;
  email: string;
  phoneNumber: string;
  caseUrl?: string;
};

export type AwaitableMergedPatientData = MergedPatientData & {
  urlPromise: Promise<string>;
};
